export const createAutoRefreshToggleHandler = ({
  currentOrg,
  setHashedEmailListAutoRefresh,
  refetchHashedEmailLists,
  applyOptimistic,
  clearOptimistic,
  setLoading,
  notify,
}) => async (record, checked) => {
  if (!currentOrg || !currentOrg.id) {
    notify.error("Organization information not available");
    return;
  }

  applyOptimistic(record.id, checked);
  setLoading(record.id, true);

  try {
    const response = await setHashedEmailListAutoRefresh({
      variables: { id: record.id, orgID: currentOrg.id, autoRefresh: checked },
    });

    let result = response && response.data && response.data.setHashedEmailListAutoRefresh;
    if (typeof result === "string") {
      try {
        result = JSON.parse(result);
      } catch (_parseError) {
        result = { success: false };
      }
    }

    if (result && result.success) {
      notify.success(checked ? "Auto-refresh enabled" : "Auto-refresh disabled");
      if (refetchHashedEmailLists) {
        await refetchHashedEmailLists();
      }
      clearOptimistic(record.id);
    } else {
      throw new Error((result && result.error) || "Failed to update auto-refresh");
    }
  } catch (error) {
    clearOptimistic(record.id);
    notify.error("Error updating auto-refresh: " + error.message);
  } finally {
    setLoading(record.id, false);
  }
};
